import { render, staticRenderFns } from "./PayrollExceptionSummary.vue?vue&type=template&id=79df4389"
import script from "./PayrollExceptionSummary.vue?vue&type=script&lang=js"
export * from "./PayrollExceptionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports